// См. two/auth/AuthTriggerAction.java
export enum AuthTriggerAction {
    Default = 'Default',

    User_Add = 'User_Add',
    User_Subscribe = 'User_Subscribe',
    User_Write = 'User_Write',
    User_SendMoney = 'User_SendMoney',
    User_SendGift = 'User_SendGift',
    User_Report = 'User_Report',
    User_SeeGroups = 'User_SeeGroups',
    User_EnterGroup = 'User_EnterGroup',
    User_SeeMusic = 'User_SeeMusic',
    User_PlayMusic = 'User_PlayMusic',
    User_Comment = 'User_Comment',
    User_Apps = 'User_Apps',
    User_Gifts = 'User_Gifts',
    User_Videos = 'User_Videos',
    User_Feed = 'User_Feed',
    User_Friends = 'User_Friends',
    User_Subscribers = 'User_Subscribers',
    User_Subscriptions = 'User_Subscriptions',
    User_Photos = 'User_Photos',
    User_Statuses = 'User_Statuses',
    User_Profile = 'User_Profile',
    User_Adverts = 'User_Adverts',
    User_AddPost = 'User_AddPost',

    Video_Save = 'Video_Save',
    Video_Report = 'Video_Report',
    Video_StartOnline = 'Video_StartOnline',
    Video_Upload = 'Video_Upload',
    Video_Comment = 'Video_Comment',
    Video_Likes = 'Video_Likes',
    Video_Reshares = 'Video_Reshares',
    Video_Comments = 'Video_Comments',
    Video_More = 'Video_More',
    Video_Channel_Subscribe = 'Video_Channel_Subscribe',
    Video_Bookmark = 'Video_Bookmark',
    Video_WatchLater = 'Video_WatchLater',
    Video_Dislike = 'Video_Dislike',
    Video_Like = 'Video_Like',
    Video_Reshare = 'Video_Reshare',

    ContentSearch_Survey = 'ContentSearch_Survey',
    ContentSearch_PlayMusic = 'ContentSearch_PlayMusic',

    Discovery_LoadMore = 'Discovery_LoadMore',

    Music_Comment = 'Music_Comment',
    Music_Play = 'Music_Play',

    Games_Play = 'Games_Play',

    Gifts_Choose = 'Gifts_Choose',
    Gifts_Send = 'Gifts_Send',

    Group_Enter = 'Group_Enter',
    Group_Bookmark = 'Group_Bookmark',
    Group_Report = 'Group_Report',
    Group_Comment = 'Group_Comment',
    Group_Links = 'Group_Links',
    Group_Likes = 'Group_Likes',
    Group_Like = 'Group_Like',
    Group_Reshare = 'Group_Reshare',
    Group_Reshares_Count = 'Group_Reshares_Count',
    Groups_Enter = 'Groups_Enter',
    Group_AddPost = 'Group_AddPost',

    Discussion_Like = 'Discussion_Like',

    Hobby_Subscribe = 'Hobby_Subscribe',
    Hobby_Complain = 'Hobby_Complain',
    Hobby_Like = 'Hobby_Like',
    Hobby_Share = 'Hobby_Share',
    Hobby_Bookmark = 'Hobby_Bookmark',
    Hobby_AddPost = 'Hobby_AddPost',
    Hobby_AddQAPost = 'Hobby_AddQAPost',

    Landing_OfferVkidBinding = 'Landing_OfferVkidBinding',

    Article_Login = 'Article_Login',
    Article_Register = 'Article_Register',
}
